import { render, staticRenderFns } from "./SiloView.vue?vue&type=template&id=6c2b46e1"
import script from "./SiloView.vue?vue&type=script&lang=js"
export * from "./SiloView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports